/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var ninjaFormsSubmitController = null;
var ninjaFormsMinimumStatementLengthController = null;
var currentlySubmitting = false;

(function($) {

  function initVariationDropdowns() {
    $('body.single-product form.variations_form select').each(function() {
      var select = this;

      if ($(select).next('.dbs-variation-dropdown').length) {
        return;
      }

      var id = select.id || 'dbs-variation-' + Math.random().toString(36).slice(2);
      var listboxId = id + '-options';
      var wrapper = $('<div class="dbs-variation-dropdown"></div>');
      var trigger = $('<button type="button" class="dbs-variation-dropdown__trigger" aria-haspopup="listbox" aria-expanded="false"></button>');
      var listbox = $('<div class="dbs-variation-dropdown__options" role="listbox"></div>').attr('id', listboxId);
      trigger.attr('aria-controls', listboxId);

      $(select).attr({
        'aria-hidden': 'true',
        'tabindex': '-1'
      }).after(wrapper);
      wrapper.append(trigger, listbox);

      function syncDropdown() {
        var selected = select.options[select.selectedIndex];
        trigger.text(selected && selected.value ? selected.text : 'Choose an option');
        listbox.empty();

        $(select).find('option').each(function(index) {
          if (!this.value) {
            return;
          }

          var option = $('<button type="button" class="dbs-variation-dropdown__option" role="option"></button>')
            .attr({
              'data-value': this.value,
              'aria-selected': this.selected ? 'true' : 'false',
              'aria-disabled': this.disabled ? 'true' : 'false'
            })
            .prop('disabled', this.disabled)
            .text(this.text);

          if (this.selected) {
            option.addClass('is-selected');
          }

          listbox.append(option);
        });
      }

      function closeDropdown() {
        wrapper.removeClass('is-open');
        trigger.attr('aria-expanded', 'false');
      }

      trigger.on('click', function() {
        var isOpen = wrapper.toggleClass('is-open').hasClass('is-open');
        trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
      });

      listbox.on('click', '.dbs-variation-dropdown__option:not(:disabled)', function() {
        $(select).val($(this).data('value')).trigger('change');
        closeDropdown();
        trigger.trigger('focus');
      });

      trigger.on('keydown', function(event) {
        var options = listbox.find('.dbs-variation-dropdown__option:not(:disabled)');
        var current = options.index(options.filter('.is-selected'));
        var next;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!wrapper.hasClass('is-open')) {
            wrapper.addClass('is-open');
            trigger.attr('aria-expanded', 'true');
          }
          next = event.key === 'ArrowDown' ? current + 1 : current - 1;
          next = next < 0 ? options.length - 1 : next >= options.length ? 0 : next;
          options.eq(next).trigger('focus');
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (wrapper.hasClass('is-open')) {
            options.eq(current < 0 ? 0 : current).trigger('click');
          } else {
            trigger.trigger('click');
          }
        } else if (event.key === 'Escape') {
          closeDropdown();
        }
      });

      listbox.on('keydown', '.dbs-variation-dropdown__option', function(event) {
        var options = listbox.find('.dbs-variation-dropdown__option:not(:disabled)');
        var current = options.index(this);
        var next;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          next = event.key === 'ArrowDown' ? current + 1 : current - 1;
          next = next < 0 ? options.length - 1 : next >= options.length ? 0 : next;
          options.eq(next).trigger('focus');
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          $(this).trigger('click');
        } else if (event.key === 'Escape') {
          closeDropdown();
          trigger.trigger('focus');
        }
      });

      $(document).on('click.dbsVariationDropdown', function(event) {
        if (!wrapper.is(event.target) && wrapper.has(event.target).length === 0) {
          closeDropdown();
        }
      });

      $(select).on('change', syncDropdown);
      $(document.body).on('woocommerce_update_variation_values found_variation reset_data', syncDropdown);
      syncDropdown();
    });
  }

  function initJetFilterDropdowns() {
    $('.jet-select .jet-select__control').each(function() {
      var select = this;
      var existing = $(select).next('.dbs-jet-filter-dropdown');
      var wrapper;
      var trigger;
      var panel;

      if (existing.length) {
        return;
      }

      wrapper = $('<div class="dbs-jet-filter-dropdown"></div>');
      trigger = $('<button type="button" class="dbs-jet-filter-dropdown__trigger" aria-haspopup="listbox" aria-expanded="false"></button>');
      panel = $('<div class="dbs-jet-filter-dropdown__panel" role="listbox"></div>');
      $(select).addClass('dbs-jet-filter-native-control').attr('aria-hidden', 'true').after(wrapper);
      wrapper.append(trigger, panel);

      function sync() {
        var selected = select.options[select.selectedIndex];
        trigger.text(selected ? selected.text : 'Choose an option');
        panel.empty();
        $(select).find('option').each(function() {
          var option = this;
          var item = $('<button type="button" class="dbs-jet-filter-dropdown__option" role="option"></button>')
            .attr('aria-selected', option.selected ? 'true' : 'false')
            .prop('disabled', option.disabled)
            .text(option.text);

          if (option.selected) {
            item.addClass('is-selected');
          }
          panel.append(item);
          item.on('click', function() {
            $(select).val(option.value).trigger('change');

            // Custom option clicks should behave like an auto-applying select,
            // even when Jet's original select is configured for submit mode.
            if ($(select).closest('.jet-filter').data('applyOn') === 'submit') {
              $(select).closest('.jet-filter').find('.apply-filters__button').first().trigger('click');
            }

            wrapper.removeClass('is-open');
            trigger.attr('aria-expanded', 'false').trigger('focus');
          });
        });
      }

      trigger.on('click', function() {
        var open = !wrapper.hasClass('is-open');
        wrapper.toggleClass('is-open', open);
        trigger.attr('aria-expanded', open ? 'true' : 'false');
      });

      trigger.on('keydown', function(event) {
        var options;
        var current;
        var next;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger.trigger('click');
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!wrapper.hasClass('is-open')) {
            trigger.trigger('click');
          }
          options = panel.find('.dbs-jet-filter-dropdown__option:not(:disabled)');
          current = options.index(options.filter('.is-selected'));
          next = event.key === 'ArrowDown' ? current + 1 : current - 1;
          next = next < 0 ? options.length - 1 : next >= options.length ? 0 : next;
          options.eq(next).trigger('focus');
        }
        if (event.key === 'Escape') {
          wrapper.removeClass('is-open');
          trigger.attr('aria-expanded', 'false');
        }
      });

      panel.on('keydown', '.dbs-jet-filter-dropdown__option', function(event) {
        var options = panel.find('.dbs-jet-filter-dropdown__option:not(:disabled)');
        var current = options.index(this);
        var next;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          next = event.key === 'ArrowDown' ? current + 1 : current - 1;
          next = next < 0 ? options.length - 1 : next >= options.length ? 0 : next;
          options.eq(next).trigger('focus');
        }
        if (event.key === 'Escape') {
          wrapper.removeClass('is-open');
          trigger.attr('aria-expanded', 'false').trigger('focus');
        }
      });

      $(select).on('change', sync);
      sync();
    });

    $('.jet-range').each(function() {
      var range = $(this);
      var wrapper;
      var trigger;
      var panel;

      if (range.closest('.dbs-jet-filter-dropdown').length) {
        return;
      }

      wrapper = $('<div class="dbs-jet-filter-dropdown dbs-jet-filter-dropdown--range"></div>');
      trigger = $('<button type="button" class="dbs-jet-filter-dropdown__trigger" aria-haspopup="dialog" aria-expanded="false"></button>')
        .text(range.closest('.jet-filter').find('.jet-filter-label').first().text() || 'Price');
      panel = $('<div class="dbs-jet-filter-dropdown__panel"></div>');
      range.wrap(wrapper);
      wrapper = range.parent();
      wrapper.prepend(trigger).append(panel);
      panel.append(range);

      trigger.on('click', function() {
        var open = !wrapper.hasClass('is-open');
        wrapper.toggleClass('is-open', open);
        trigger.attr('aria-expanded', open ? 'true' : 'false');
      });

      // Jet updates slider values on input and applies them on mouseup.
      range.on('input', '.jet-range__slider__input', function() {
        $(this).trigger('mouseup');
      });

    });

    $(document).off('click.dbsJetFilters').on('click.dbsJetFilters', function(event) {
      $('.dbs-jet-filter-dropdown.is-open').each(function() {
        if (!$(this).is(event.target) && !$(this).has(event.target).length) {
          $(this).removeClass('is-open').find('[aria-expanded="true"]').attr('aria-expanded', 'false');
        }
      });
    }).off('keydown.dbsJetFilters').on('keydown.dbsJetFilters', function(event) {
      if (event.key === 'Escape') {
        $('.dbs-jet-filter-dropdown.is-open').removeClass('is-open')
          .find('[aria-expanded="true"]').attr('aria-expanded', 'false');
      }
    });
  }

  function initShareButtons() {
    $(document).off('click.dbsShareButtons', '[data-share-network]').on('click.dbsShareButtons', '[data-share-network]', function(event) {
      var button = $(this);
      var network = button.data('share-network');

      if (network === 'email') {
        return;
      }

      event.preventDefault();
      window.open(button.attr('href'), 'bransby-share', 'width=600,height=500,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes');
    });
  }

  function applyAccessibilityTheme(theme) {
    $('body').removeClass('accessibility-yellow-on-black accessibility-black-on-yellow');
    if (theme === 'yob') {
      $('body').addClass('accessibility-yellow-on-black');
    }
    if (theme === 'boy') {
      $('body').addClass('accessibility-black-on-yellow');
    }
  }

  function applyAccessibilityText(text) {
    $('body').removeClass('accessibility-bolder accessibility-bold');
    if (text === 'bolder') {
      $('body').addClass('accessibility-bolder');
    }
    if (text === 'bold') {
      $('body').addClass('accessibility-bold');
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var mobileNav = $('#mobile-nav');

        $('.header__menu-button').on('click', function() {
          mobileNav.toggleClass('is-open');
          $('body').toggleClass('mobile-nav-open', mobileNav.hasClass('is-open'));
          $(this).attr('aria-expanded', mobileNav.hasClass('is-open'));
        });

        $('.mobile-nav__close').on('click', function() {
          mobileNav.removeClass('is-open');
          $('body').removeClass('mobile-nav-open');
          $('.header__menu-button').attr('aria-expanded', 'false');
        });

        $(document).on('keydown', function(event) {
          if (event.key === 'Escape') {
            mobileNav.removeClass('is-open');
            $('body').removeClass('mobile-nav-open');
            $('.header__menu-button').attr('aria-expanded', 'false');
            $('.shop-mega-menu').removeClass('is-open').attr('aria-hidden', 'true');
            $('.shop-navigation [data-shop-mega]').attr('aria-expanded', 'false');
          }
        });

        $('.mobile-nav__section-toggle').on('click', function() {
          var section = $(this).closest('.mobile-nav__section');
          section.toggleClass('is-open');
          $(this).attr('aria-expanded', section.hasClass('is-open'));
          $(this).find('span').text(section.hasClass('is-open') ? '−' : '+');
        });

        $('.mobile-nav__column-heading').on('click', function(event) {
          var column = $(this).closest('.mobile-nav__column');
          if (column.find('ul').length) {
            event.preventDefault();
            column.toggleClass('is-open');
          }
        });

        mobileNav.find('li').has('> ul').each(function() {
          var item = $(this);
          var link = item.children('a');
          var toggle = $('<button type="button" class="mobile-nav__item-toggle" aria-expanded="false">+</button>');
          link.after(toggle);
          toggle.on('click', function() {
            item.toggleClass('is-open');
            toggle.attr('aria-expanded', item.hasClass('is-open')).text(item.hasClass('is-open') ? '−' : '+');
          });
        });

        $('.shop-navigation [data-shop-mega]').on('click', function() {
          var target = $(this).data('shop-mega');
          var megaMenu = $('.shop-mega-menu[data-shop-menu="' + target + '"]');
          $('.shop-mega-menu').not(megaMenu).removeClass('is-open').attr('aria-hidden', 'true');
          $('.shop-navigation [data-shop-mega]').not(this).attr('aria-expanded', 'false');
          megaMenu.toggleClass('is-open');
          megaMenu.attr('aria-hidden', !megaMenu.hasClass('is-open'));
          $(this).attr('aria-expanded', megaMenu.hasClass('is-open'));
        });

        $('.header__menu--shop').on('focusout', function(event) {
          if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
            $('.shop-mega-menu').removeClass('is-open').attr('aria-hidden', 'true');
            $('.shop-navigation [data-shop-mega]').attr('aria-expanded', 'false');
          }
        });

        var theme = Cookies.get('accessibility_theme');
        if (theme) {
          applyAccessibilityTheme(theme);
        }

        $('.square-icons__item--theme-normal').click(function () {
          Cookies.remove('accessibility_theme');
          applyAccessibilityTheme();
        });
        $('.square-icons__item--theme-yellow').click(function () {
          Cookies.set('accessibility_theme', 'boy', { expires: 365 });
          applyAccessibilityTheme('boy');
        });
        $('.square-icons__item--theme-black').click(function () {
          Cookies.set('accessibility_theme', 'yob', { expires: 365 });
          applyAccessibilityTheme('yob');
        });

        $('[data-ride=carousel] > .carousel-inner').slick({
          arrows: false,
          dots: false,
          autoplay: false
        });

        var productCards = document.querySelectorAll('[data-product-carousel] .bransby-product-card, [data-products-grid] .bransby-product-card');

        for (var productCardIndex = 0; productCardIndex < productCards.length; productCardIndex++) {
          (function(productCard) {
            jQuery(document.body).on('added_to_cart', function(event, fragments, cartHash, target) {
              var addButton = target && target.jquery ? target[0] : target;
              var targetCard = addButton && addButton.closest ? addButton.closest('.bransby-product-card') : null;
              var basketLink;

              if (!targetCard && addButton && addButton.matches && addButton.matches('li.product')) {
                targetCard = addButton;
                addButton = targetCard.querySelector('.add_to_cart_button');
              }

              if (targetCard !== productCard || !addButton || !addButton.parentNode) {
                return;
              }

              basketLink = document.createElement('a');
              basketLink.href = productCard.closest('[data-cart-url]').getAttribute('data-cart-url');
              basketLink.className = 'button added_to_cart wc-forward';
              basketLink.rel = 'nofollow';
              basketLink.textContent = 'View';
              addButton.parentNode.replaceChild(basketLink, addButton);
            });
          }(productCards[productCardIndex]));
        }

        var relatedCarousels = document.querySelectorAll('[data-related-products-carousel]');

        for (var carouselIndex = 0; carouselIndex < relatedCarousels.length; carouselIndex++) {
          (function(carousel) {
            var viewport = carousel.querySelector('.bransby-related-products-carousel__viewport');
            var trackElement = carousel.querySelector('.bransby-related-products-carousel__track');
            var previousArrow = carousel.querySelector('.bransby-related-products-carousel__arrow--prev');
            var nextArrow = carousel.querySelector('.bransby-related-products-carousel__arrow--next');
            var resizeTimer;

            function updateCarousel() {
              var width = viewport.clientWidth;
              var slidesToShow = window.innerWidth < 767 ? 1 : (window.innerWidth < 991 ? 2 : 3);
              var gap = slidesToShow === 3 ? 20 : (slidesToShow === 2 ? 16 : 12);
              var slideWidth = Math.floor((width - (gap * (slidesToShow - 1))) / slidesToShow);
              var maxScroll = trackElement.scrollWidth - width;

              if (slideWidth <= 0) {
                return;
              }

              trackElement.style.setProperty('--carousel-slide-width', slideWidth + 'px');
              previousArrow.disabled = trackElement.scrollLeft <= 1;
              nextArrow.disabled = trackElement.scrollLeft >= maxScroll - 1;
              trackElement.classList.add('is-loaded');
            }

            previousArrow.addEventListener('click', function() {
              trackElement.scrollBy({ left: -(viewport.clientWidth * 0.9), behavior: 'smooth' });
            });

            nextArrow.addEventListener('click', function() {
              trackElement.scrollBy({ left: viewport.clientWidth * 0.9, behavior: 'smooth' });
            });

            trackElement.addEventListener('scroll', updateCarousel, { passive: true });
            window.addEventListener('resize', function() {
              window.clearTimeout(resizeTimer);
              resizeTimer = window.setTimeout(updateCarousel, 100);
            });
            window.setTimeout(updateCarousel, 0);
         }(relatedCarousels[carouselIndex]));
        }

        var categoryCarousels = document.querySelectorAll('[data-product-categories-carousel], [data-product-carousel]');

        for (var categoryIndex = 0; categoryIndex < categoryCarousels.length; categoryIndex++) {
          (function(carousel) {
            var productCarousel = carousel.hasAttribute('data-product-carousel');
            var classPrefix = productCarousel ? 'bransby-product-carousel' : 'bransby-product-categories-carousel';
            var viewport = carousel.querySelector('.' + classPrefix + '__viewport');
            var track = carousel.querySelector('.' + classPrefix + '__track');
            var previous = carousel.querySelector('.bransby-related-products-carousel__arrow--prev');
            var next = carousel.querySelector('.bransby-related-products-carousel__arrow--next');
            var dragStart = 0;
            var dragOffsetStart = 0;
            var currentOffset = 0;
            var maxOffset = 0;
            var isDragging = false;
            var moved = false;

            if (!viewport || !track || !previous || !next) {
              return;
            }

            function updateCategoryCarousel() {
              var slidesToShow;
              var gap;
              var slideWidth;
              maxOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);

              if (productCarousel) {
                slidesToShow = window.innerWidth < 768 ? 1 : (window.innerWidth < 992 ? 2 : 3);
                var trackStyle = window.getComputedStyle(track);
                gap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
                slideWidth = Math.floor((viewport.clientWidth - (gap * (slidesToShow - 1))) / slidesToShow);
                if (slideWidth > 0) {
                  track.style.setProperty('--carousel-slide-width', slideWidth + 'px');
                  maxOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);
                }
              }

              currentOffset = Math.max(0, Math.min(currentOffset, maxOffset));
              track.style.transform = 'translateX(-' + currentOffset + 'px)';
              previous.disabled = currentOffset <= 1;
              next.disabled = currentOffset >= maxOffset - 1;
            }

            function getCategoryScrollDistance() {
              var item = track.querySelector(productCarousel ? 'li.product' : '.bransby-product-categories-carousel__item');
              var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
              return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
            }

            previous.addEventListener('click', function() {
              currentOffset = Math.max(0, currentOffset - getCategoryScrollDistance());
              track.style.transform = 'translateX(-' + currentOffset + 'px)';
              updateCategoryCarousel();
            });

            next.addEventListener('click', function() {
              currentOffset = Math.min(maxOffset, currentOffset + getCategoryScrollDistance());
              track.style.transform = 'translateX(-' + currentOffset + 'px)';
              updateCategoryCarousel();
            });

            track.addEventListener('pointerdown', function(event) {
              if (event.pointerType === 'mouse' && event.button !== 0) {
                return;
              }
              dragStart = event.clientX;
              dragOffsetStart = currentOffset;
              isDragging = true;
              moved = false;
              if (event.pointerType !== 'mouse') {
                track.setPointerCapture(event.pointerId);
              }
              track.style.transition = 'none';
            });

            track.addEventListener('pointermove', function(event) {
              if (!isDragging) {
                return;
              }
              var distance = event.clientX - dragStart;
              if (Math.abs(distance) > 4) {
                moved = true;
              }
              currentOffset = Math.max(0, Math.min(maxOffset, dragOffsetStart - distance));
              track.style.transform = 'translateX(-' + currentOffset + 'px)';
              updateCategoryCarousel();
            });

            track.addEventListener('pointerup', function(event) {
              if (!isDragging) {
                return;
              }
              isDragging = false;
              track.style.transition = '';
              if (track.hasPointerCapture(event.pointerId)) {
                track.releasePointerCapture(event.pointerId);
              }
              window.setTimeout(function() {
                moved = false;
              }, 0);
            });

            track.addEventListener('pointercancel', function() {
              isDragging = false;
              track.style.transition = '';
            });

            window.addEventListener('resize', updateCategoryCarousel);
            window.setTimeout(updateCategoryCarousel, 0);
            window.setTimeout(updateCategoryCarousel, 250);
          }(categoryCarousels[categoryIndex]));
        }

        var reviewsCarousels = document.querySelectorAll('[data-reviews-carousel]');

        for (var reviewsIndex = 0; reviewsIndex < reviewsCarousels.length; reviewsIndex++) {
          (function(carousel) {
            var track = carousel.querySelector('.bransby-reviews-carousel__track');
            var pages = carousel.querySelectorAll('.bransby-reviews-carousel__page');
            var previous = carousel.querySelector('.bransby-reviews-carousel__arrow--prev');
            var next = carousel.querySelector('.bransby-reviews-carousel__arrow--next');
            var currentPage = 0;

            if (!track || pages.length < 2 || !previous || !next) {
              return;
            }

            function updateReviewsCarousel() {
              track.style.transform = 'translateX(-' + (currentPage * 100) + '%)';
              previous.disabled = currentPage === 0;
              next.disabled = currentPage === pages.length - 1;
            }

            previous.addEventListener('click', function() {
              if (currentPage > 0) {
                currentPage--;
                updateReviewsCarousel();
              }
            });

            next.addEventListener('click', function() {
              if (currentPage < pages.length - 1) {
                currentPage++;
                updateReviewsCarousel();
              }
            });

            updateReviewsCarousel();
          }(reviewsCarousels[reviewsIndex]));
        }

        /*
        $('.featured-stories, .featured-news').slick({
          arrows: false,
          dots: true,
          customPaging: function (slider, i) {
            return '<button></button>';
          },
          autoplay: true,
          autoplaySpeed: 5000
        });

        $('.adoption-gallery__slider').slick({
          arrows: true,
          dots: false,
          slidesToShow: 6,
          slidesToScroll: 6,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        $('.adoption-gallery__slider').slickLightbox({
          itemSelector: '.adoption-gallery__slide > a',
          caption: function (el) {
            var name = $(el).find('.adoption-gallery__name').text();
            var caption = $(el).find('.adoption-gallery__caption').html();
            var link = $(el).find('.adoption-gallery__adoption_link').text();
            if (link) {
              caption += '<a class="btn btn-lg btn-primary btn-do-navigate" href="' + link + '">Adopt ' + name + "</a>";
            }
            return caption;
          }
        });
        */

        $('body').on('click', '.btn-do-navigate', function (event) {
          window.location = event.target.href;
        });

        if ($('[name="ok-donation"]').val() === '0') {
          $('[name="ok-donation"]').val('');
        }

        $('[name="ok-donation"]').before('<span class="donation-currency">£</span>');
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');

      initVariationDropdowns();
      initJetFilterDropdowns();
      initShareButtons();

      jQuery('.bransby-donation-widget').each(function() {
        var widget = jQuery(this);
        var form = widget.find('form');
        var amount = form.find('[name=alg_open_price]');
        var message = widget.find('.bransby-donation-widget__message');

        widget.on('click', '.bransby-donation-widget__preset', function() {
          var preset = jQuery(this);
          widget.find('.bransby-donation-widget__preset').removeClass('is-selected');
          preset.addClass('is-selected');
          amount.val(preset.data('amount'));
        });

        form.on('submit', function(event) {
          var data;

          event.preventDefault();
          message.text('');
          if (!amount.val() || parseFloat(amount.val()) <= 0) {
            message.text('Please enter a donation amount.');
            amount.trigger('focus');
            return;
          }

          data = form.serialize() + '&product_sku=&product_id=' + encodeURIComponent(form.find('[name=product_id]').val());
          jQuery.ajax('/?wc-ajax=add_to_cart', { type: 'POST', data: data })
            .done(function(response) {
              jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, form]);
              message.text('Thank you for your donation.');
            })
            .fail(function() {
              message.text('Unable to add donation. Please try again.');
            });
        });
      });

      jQuery("a.woocommerce-loop-product__link").click(function(ev) {
        if (ev.target.classList.contains("fa") || ev.target.classList.contains("carousel-control-next") || ev.target.classList.contains("carousel-control-prev"))
        {
          var carousel = ev.currentTarget.querySelector(".carousel-inner");
          if (carousel == null)
          {
            return;
          }

          ev.preventDefault();
          ev.stopImmediatePropagation();

          if (ev.target.classList.contains("fa-chevron-left") || ev.target.classList.contains("carousel-control-prev"))
          {
			jQuery(carousel).slick('slickPrev');
          }
          else
          {
			jQuery(carousel).slick('slickNext');
          }
        }
      });

      jQuery(document).on("change input", ".woocommerce-cart-form .cart_item :input", function (ev) {
        jQuery('.woocommerce-cart-form :input[name="update_cart"]').click();
      });

      /*
      jQuery(document.body).on("added_to_cart", function (ev, content, hash, target) {
        var sourceProduct = jQuery(target).parent();
        var title = jQuery(sourceProduct).find(".product > .product_title").text();
        if (!title) {
          title = jQuery(sourceProduct).find(".woocommerce-loop-product__title").text();
        }
        var modalContent = '<div id="add_to_cart_modal" class="modal fade"><div class="modal-dialog"><div class="modal-content"><div class="modal-body">' +
          '<h3>' + title + '<br /><small>Added to cart</small></h3>' +
          jQuery(sourceProduct).find("img").first()[0].outerHTML +
          '<div class="row"><div class="col-md-6"><a href="#" data-dismiss="modal">Continue shopping</a></div><div class="col-md-6"><a href="/shop/cart/">Go to cart</a></div></div>' +
          '</div></div></div></div>';
        jQuery("div#cookies").before(modalContent);
        jQuery("div#add_to_cart_modal").on("hidden.bs.modal", function() {
          jQuery("div#add_to_cart_modal").modal("dispose");
          jQuery("div#add_to_cart_modal").remove();
        });
        jQuery("div#add_to_cart_modal").modal("show");

      });
      */

      jQuery("body.single-product form.cart").on("submit", function(ev) {
        ev.preventDefault();
        var form = jQuery(ev.currentTarget);
        var data = form.serialize() +
          "&product_sku=" + encodeURIComponent(form.find("[name=gtm4wp_sku]").val() || "") +
          "&product_id=" + encodeURIComponent(form.find("[name=add-to-cart]").val()) +
          "&quantity=" + encodeURIComponent(form.find("[name=quantity]").val());
        jQuery.ajax("/?wc-ajax=add_to_cart", {
          type: "POST",
          enctype: 'multipart/form-data',
          data: data
        })
          .done(function (response) {
            $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, jQuery(".single_product_wrapper .product") ] );
          });
      });

      jQuery(document.body).on('added_to_cart', function(ev, content, hash, target) {
        var product = target && target.jquery ? target[0] : target;
        var form = product && product.querySelector ? product.querySelector('form.cart') : document.querySelector('body.single-product form.cart');

        if (!form || form.querySelector('.dbs-single-product-view-basket')) {
          return;
        }

        var basketLink = document.createElement('a');
        basketLink.href = document.body.getAttribute('data-cart-url') || '/shop/cart/';
        basketLink.className = 'added_to_cart wc-forward dbs-single-product-view-basket';
        basketLink.rel = 'nofollow';
        basketLink.textContent = 'View basket';
        var buttonRow = form.querySelector('.dbs-single-product-buttons');
        (buttonRow || form).appendChild(basketLink);
      });

      jQuery("body.single-product form.cart .quantity").each(function() {
        var quantity = jQuery(this);
        var input = quantity.find("input.qty");

        if (!input.length || quantity.find(".quantity-button").length) {
          return;
        }

        quantity.prepend('<button type="button" class="quantity-button quantity-button--decrease" aria-label="Decrease quantity">-</button>');
        quantity.append('<button type="button" class="quantity-button quantity-button--increase" aria-label="Increase quantity">+</button>');

        quantity.on("click", ".quantity-button", function() {
          var min = parseFloat(input.attr("min")) || 1;
          var max = parseFloat(input.attr("max"));
          var step = parseFloat(input.attr("step")) || 1;
          var value = parseFloat(input.val()) || min;
          var next = jQuery(this).hasClass("quantity-button--increase") ? value + step : value - step;

          if (next < min) {
            next = min;
          }
          if (!isNaN(max) && next > max) {
            next = max;
          }

          input.val(next).trigger("change");
        });
      });

      /*
      window.addEventListener("consent.onetrust", function () {
        if (OnetrustActiveGroups.indexOf(",C0004,") === -1)
        {
          return;
        }

        var fallbacks = document.querySelectorAll(".cookie-iframe-fallback");
        for (var i= 0; i < fallbacks.length; i++)
        {
          fallbacks[i].remove();
        }
      });

      var iframes = document.querySelectorAll("iframe[data-src]");
      for (var i= 0; i < iframes.length; i++)
      {
        var ot_cookie = Cookies.get("OptanonConsent");
        if (!ot_cookie || ot_cookie.indexOf("C0004:1") === -1)
        {
          var fallback = document.createElement("div");
          fallback.className = "cookie-iframe-fallback";
          fallback.innerText = "This video has not loaded as you have not allowed targeting cookies on your device whilst visiting our website. Click for more information, to accept cookies and play the video.";

          var fallbackBtn = document.createElement("button");
          fallbackBtn.type = "button";
          fallbackBtn.innerText = "Click here";

          var loadCookie = function (ev) { ev.preventDefault(); OneTrust.ToggleInfoDisplay(); };
          fallback.addEventListener("click", loadCookie);
          fallbackBtn.addEventListener("click", loadCookie);

          fallback.appendChild(fallbackBtn);
          iframes[i].parentNode.appendChild(fallback);
        }
      }
     */

      if (typeof(Marionette) !== 'undefined' && !!Marionette && typeof(Backbone) !== 'undefined' && !!Backbone) {
        ninjaFormsSubmitController = Marionette.Object.extend({
          initialize: function() {
            var forms = document.getElementsByClassName("nf-form-cont");
            for(var i = 0; i < forms.length; i++)
            {
              var id = document.getElementsByClassName("nf-form-cont")[i].id.replace("nf-form-", "").replace("-cont", "");
              Backbone.Radio.channel('form-' + id).reply('maybe:submit', this.beforeSubmit, this);
            }
            this.listenTo(Backbone.Radio.channel( 'forms' ), 'submit:response', this.actionSubmit);
          },
          beforeSubmit: function() {
            if (currentlySubmitting)
            {
              return false;
            }
            currentlySubmitting = true;
            return true;
          },
          actionSubmit: function (response) {
            currentlySubmitting = false;
          }
        });

        new ninjaFormsSubmitController();

        ninjaFormsMinimumStatementLengthController = Marionette.Object.extend({
          initialize: function() {
            var submitChannel = Backbone.Radio.channel( 'submit' );
            this.listenTo( submitChannel, 'validate:field', this.validate );

            var fieldsChannel = Backbone.Radio.channel( 'fields' );
            this.listenTo( fieldsChannel, 'change:modelValue', this.validate );
          },
          validate: function (model) {
            var modelID = model.get( 'id' );
            var formID = model.get( 'formID' );
            var errorID = 'requires-more-characters';
            var errorMessage = 'Please enter at least 250 words.';

            if (modelID == 631 && formID == 17) {
              var regex = /\s+/gi;
              var value = model.get( 'value' );
              var words = value.trim().replace(regex, ' ').split(' ');
              if (words.length < 250) {
                Backbone.Radio.channel( 'fields' ).request( 'add:error', modelID, errorID, errorMessage );
              }
              else {
                Backbone.Radio.channel( 'fields' ).request( 'remove:error', modelID, errorID );
              }
            }
          }
        });
        new ninjaFormsMinimumStatementLengthController();
      }

      jQuery("[data-dbs-expand].elementor-widget-button").click(function(ev) {
        ev.preventDefault();
        var target = jQuery(this).data("dbs-expand");
        if (target) {
          jQuery("[data-dbs-expand=" + target + "]").toggleClass("expanded");
        }
      });

      jQuery("[data-toggle=collapse]").click(function(ev) {
        var target = jQuery(this).data("target");
        if (!target) {
          target = jQuery(this).attr("href");
        }

        if (target) {
          ev.preventDefault();
          var isExpanded = jQuery(this).attr("aria-expanded") === "true";
          if (isExpanded) {
            jQuery(this).attr("aria-expanded", "false");
          }
          else {
            jQuery(this).attr("aria-expanded", "true");
          }
          jQuery(target).toggleClass("show");
        }
      });
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  if ( window.gform != null ) {
    window.gform.addFilter( 'gform_geolocation_autocomplete_options_pre_init', function ( options, formId, fieldId, address ) {
      options.componentRestrictions = { country: 'GB' };
      return options;
    } );
  }

})(jQuery); // Fully reference jQuery after this point.
